import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { listAgents } from '@/lib/api'
import type { Agent } from '@/types'
import { DataTable, type Column } from '@/components/ui/DataTable'
import { StatusDot } from '@/components/ui/StatusDot'
import { Badge } from '@/components/ui/Badge'
import { PendingBackendNotice } from '@/components/ui/EmptyState'

export function AgentsList() {
  const [agents, setAgents] = useState<Agent[]>([])
  const navigate = useNavigate()

  useEffect(() => {
    listAgents().then(setAgents)
  }, [])

  const columns: Column<Agent>[] = [
    { header: 'Agente', cell: (a) => a.name },
    { header: 'ID', cell: (a) => a.id, mono: true },
    { header: 'Canal', cell: (a) => a.channel ?? '—' },
    { header: 'Estado', cell: (a) => <StatusDot status={a.status} /> },
    {
      header: 'Stack',
      cell: (a) => (
        <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
          {(a.tech_stack ?? []).map((t) => <Badge key={t}>{t}</Badge>)}
        </div>
      ),
    },
    { header: 'Presupuesto/mes', cell: (a) => a.monthly_budget_usd ? `$${a.monthly_budget_usd}` : '—', mono: true },
  ]

  return (
    <div>
      <PendingBackendNotice endpoint="GET /agents" />
      <h1 style={{ fontSize: 20, fontWeight: 500, marginBottom: 16 }}>Agentes</h1>
      <DataTable
        columns={columns}
        rows={agents}
        getRowKey={(a) => a.id}
        onRowClick={(a) => navigate(`/agents/${a.id}`)}
      />
    </div>
  )
}
